var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"title",rawName:"v-title"}],attrs:{"id":"app","data-title":"零碳在线"}},[_c('div',{staticClass:"app_container"},[_c('div',{staticClass:"contain",staticStyle:{}},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }